import React from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

export default function Header() {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className="sticky top-0 z-50 backdrop-blur-xl bg-[#F9F9F6]/70 border-b border-black/5"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between py-5">
        <Link
          to="/"
          className="flex items-center gap-2 group"
          data-testid="brand-logo"
        >
          <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-[#1A365D] text-white">
            <Sparkles className="h-4 w-4" />
          </span>
          <span className="font-serif text-xl tracking-tight text-[#111827]">
            No Grime, <span className="italic text-[#1A365D]">Window Shine</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-10 text-sm uppercase tracking-[0.18em] text-[#4B5563]">
          <button
            onClick={() => scrollTo("about")}
            className="hover:text-[#1A365D] transition-colors"
            data-testid="nav-about"
          >
            About
          </button>
          <button
            onClick={() => scrollTo("services")}
            className="hover:text-[#1A365D] transition-colors"
            data-testid="nav-services"
          >
            Services
          </button>
          <button
            onClick={() => scrollTo("request")}
            className="hover:text-[#1A365D] transition-colors"
            data-testid="nav-availability"
          >
            Availability
          </button>
        </nav>

        <button
          onClick={() => scrollTo("quote")}
          className="hidden sm:inline-flex items-center rounded-full border border-[#1A365D] bg-[#1A365D] px-5 py-2.5 text-sm text-white uppercase tracking-[0.15em] hover:bg-[#2B4C7E] transition-colors"
          data-testid="header-cta-get-quote"
        >
          Get Quote
        </button>
      </div>
    </header>
  );
}
